<div
  #helpDialog
  aria-describedby="modal-description"
  aria-labelledby="modal-title"
  class="help-modal"
  role="dialog"
  tabindex="0"
>
  <div class="container content mt-lg-0 border-top-0 p-0">
    <button
      (click)="close()"
      class="help-modal-close icon-moreoptionsclose float-right circle-outline"
      type="button"
    >
      <img
        alt="close"
        class="ng-tns-c0-0"
        src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
      />
    </button>
    <span class="sr-only" id="modal-title">
      {{ tooltipContent?.tooltiptitle }} Dialog
    </span>
    <h4 [innerHTML]="tooltipContent?.tooltiptitle" class="title"></h4>
    <div class="modal-body pl-0 pr-0">
      <p
        [innerHTML]="tooltipContent?.tooltipDescription"
        id="modal-description"
      ></p>
    </div>
  </div>
</div>
